import defaultSettings from './defaultSettings'

const getMapScript = () => {
  // 每次加载地图都需要配置地图设置
  const win: any = window
  const userSettings = Object.assign({}, defaultSettings)
  if (!win.BMapGL) {
    const ak = userSettings.ak
    win.BMapGL = {}
    win.BMapGL._preloader = new Promise((resolve) => {
      win._initBaiduMap = function () {
        resolve(win.BMapGL)
        win.BMapGL._preloader = null
        win._initBaiduMap = null
      }
      const $script = document.createElement('script')
      $script.type = 'text/javascript'
      $script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${ak}&callback=_initBaiduMap`
      document.head.appendChild($script)
    })
    return win.BMapGL._preloader
  } else if (!win.BMapGL._preloader) {
    return Promise.resolve(win.BMapGL)
  } else {
    return win.BMapGL._preloader
  }
}
export default getMapScript
